import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m a <b className="purple">Senior Data Engineer</b> who loves
              designing scalable, cloud-native data platforms and real-time
              analytics systems. Over the years, I’ve built data pipelines that
              transform raw information into actionable insights across
              healthcare, finance, and enterprise domains.
              <br />
              <br />
              My expertise lies in
              <i>
                <b className="purple">
                  {" "}
                  Python, SQL, Spark, Airflow, dbt, Kafka, and Snowflake{" "}
                </b>
              </i>
              — and I work hands-on across AWS, Azure, and GCP ecosystems.
              <br />
              <br />
              I’m deeply interested in building
              <i>
                <b className="purple"> Data Lakehouse architectures </b>
              </i>
              and automating data workflows through
              <i>
                <b className="purple"> CI/CD and Infrastructure as Code </b>
              </i>
              using Terraform and Kubernetes.
              <br />
              <br />
              Whenever possible, I focus on engineering systems that are
              <b className="purple"> observable, secure, and cost-efficient</b>,
              supporting downstream ML and analytics at scale.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="Shaun K Avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
